import styles from './FJStrokePanel.module.less';
import PropTypes from 'prop-types';
import FJImage from '../FJImage/FJImage';
import FJConfig from '../../../config/FJConfig';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import FJNoneIcon from '../../../assets/svg/none.svg?react';
import FJTextWithEllipsis from '../FJTextWithEllipsis/FJTextWithEllipsis';
import FJSideModelSelectedInputBox from '../FJSideModelSelectedInputBox/FJSideModelSelectedInputBox';
import FJLocalStore from '../../../store/FJLocalStore';
import { useMemo } from 'react';
import FJStrokeSet from '../FJStrokeSet/FJStrokeSet';
import FJVerticalScroller from '../FJScroller/FJVerticalScroller.jsx';
import { STROKE_LIST } from '@fj/fj-image-stroke';

const FJStrokePanel = ({ handleApplyToAll, strokeApplyToAll, strokeInfo, onStrokeInfoChange, isShowApplyToAll }) => {
    const selectedStrokeType = useMemo(() => {
        return strokeInfo.type;
    }, [strokeInfo]);

    const _getComp = useMemo(() => {
        let selectIndex = -1;

        const listComponent = STROKE_LIST.map((item, index) => {
            const active = selectedStrokeType === item.type;
            if (active) {
                selectIndex = index;
            }

            return (
                <div className={styles.stroke_item_box} key={item.type}>
                    <FJHoverBoardGradation
                        borderRadius={8}
                        className={styles.stroke_item}
                        active={active}
                        isShowInBorder={true}
                        onClick={() => onStrokeInfoChange({ strokeInfo: item }, undefined, true)}
                    >
                        <FJImage imgSrc={FJConfig.strokeImageBaseUrl + item.type + '.png'} />
                    </FJHoverBoardGradation>
                    <FJTextWithEllipsis className={styles.stroke_item_text} text={FJLocalStore._(item.type)} />
                </div>
            );
        });

        if (selectIndex !== -1) {
            let insertIndex = selectIndex + 1;
            insertIndex += 4;
            insertIndex -= insertIndex % 4;

            listComponent.splice(
                insertIndex - 1,
                0,
                <FJStrokeSet
                    key='setStroke'
                    selectedIndex={selectIndex + 1}
                    strokeInfo={strokeInfo}
                    onStrokeInfoChange={onStrokeInfoChange}
                    style={{ margin: '0px' }}
                    itemWidth={74}
                    space={12}
                />,
            );
        }

        return listComponent;
    }, [strokeInfo, onStrokeInfoChange, selectedStrokeType]);

    const isShowImg = useMemo(() => {
        return strokeInfo.type !== 'none';
    }, [strokeInfo]);

    return (
        <FJSideModelSelectedInputBox
            title={'stroke'}
            selectedName={FJLocalStore._(strokeInfo.type)}
            checkBoxText={'apply-to-all'}
            isShowCheckBox={isShowApplyToAll}
            isShowArrowIcon={true}
            checked={strokeApplyToAll}
            checkBoxChange={handleApplyToAll}
            isShowImg={isShowImg}
            className={styles.stroke_panel}
            imgUrl={FJConfig.strokeImageBaseUrl + strokeInfo.type + '.png'}
            modelPosition={{ top: 360, left: 478 }}
        >
            <div className={styles.title}>{FJLocalStore._('stroke')}</div>

            <FJVerticalScroller className={styles.stroke_box}>
                <div className={styles.stroke_item_box}>
                    <FJHoverBoardGradation
                        borderRadius={8}
                        className={styles.stroke_item_none}
                        contentClassName={styles.stroke_item_none_content}
                        active={selectedStrokeType === 'none'}
                        onClick={() => onStrokeInfoChange({ strokeInfo: { type: 'none' } }, undefined, true)}
                    >
                        <FJNoneIcon className={styles.none_icon} />
                    </FJHoverBoardGradation>
                    <FJTextWithEllipsis className={styles.stroke_item_text} text={FJLocalStore._('none')} />
                </div>
                {_getComp}
            </FJVerticalScroller>
        </FJSideModelSelectedInputBox>
    );
};

FJStrokePanel.propTypes = {
    handleApplyToAll: PropTypes.func,
    strokeApplyToAll: PropTypes.bool,
    isShowApplyToAll: PropTypes.bool,
};

export default FJStrokePanel;
